import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import InfoManual from "../servicios/InfoManual";
const Footer = lazy(() => import('../footer/Footer'));
function Manual() {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="En Hyundai nos preocupamos por ti y tu vehículo. Revisa el manual de propietario de tu Hyundai"
        />
        <meta name="keywords" content="manual Hyundai" />
        <title>Manuales Hyundai</title>
      </Helmet>
      <Menu />
      <InfoManual />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default Manual;